.skeleton {
  display: block;
  background: linear-gradient(90deg, var(--vc-bg-subtle) 25%, #e9ebf2 37%, var(--vc-bg-subtle) 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
  border-radius: var(--vc-radius-sm);

  &.circle {
    border-radius: 50%;
  }
}

@keyframes shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.spinnerWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: var(--vc-text-muted);
  gap: 10px;
  font-size: var(--vc-text-sm);
}

// `.spinner` is also rendered on its own (size="sm"), so it is not nested under `.spinnerWrap`.
.spinner {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2.5px solid var(--vc-border-strong);
  border-top-color: var(--vc-brand);
  animation: spin 0.8s linear infinite;

  &.spinnerSm {
    width: 16px;
    height: 16px;
    border-width: 2px;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
